import * as actions from './actions'
import { FullscreenState } from './model';
import { FullscreenActions } from './actions'

const initialState: FullscreenState = {
  isFullscreen: false
};

const reducer = (state: FullscreenState = initialState, action: FullscreenActions): FullscreenState => {
  switch (action.type) {
    case actions.Expand:
      return {
        ...state,
        isFullscreen: true
      };
    case actions.Collapse:
      return {
        ...state,
        isFullscreen: false
      };
    default:
      return state
  }
};

export default reducer
